import { z } from "zod";

const UserMediaSchema = z.object({
  type: z.enum(["image", "video"]),
  url: z.string(),
  source: z.literal("user")
});

const ShutterstockMediaSchema = z.object({
  type: z.enum(["image", "video"]),
  url: z.string(),
  source: z.literal("shutterstock"),
  externalId: z.string(),
  searchId: z.string().optional()
});

const MediaSchema = z.union([UserMediaSchema, ShutterstockMediaSchema]);

export const LocationSchema = z
  .object({
    location: z.string(),
    stateOfLoc: z.string(),
    country: z.string(),
    twoLetterCountry: z.string(),
    type: z.enum(["city", "state", "country", "region"]),
    radius: z.number(),

    // Fields from the error logs: Allow null AND undefined
    placeIdResults: z.array(
      z.object({
        long_name: z.string(),
        short_name: z.string(),
        types: z.array(z.string())
      })
    ),
    extra: z.string(),
    label: z.string(),
    region: z.string()
  })
  .partial();

const CAMPAIGN_STATUS = {
  ACTIVE: "ACTIVE",
  DRAFT: "DRAFT",
  NEW: "NEW",
  // OLD BOOKING CAMPAIGN STATUSES
  IN_PROGRESS: "IN_PROGRESS",
  WAITING_FOR_APPROVAL: "WAITING_FOR_APPROVAL",
  SCHEDULED: "SCHEDULED",
  PAUSED: "PAUSED",
  FINISHED: "FINISHED",
  REJECTED: "REJECTED",
  CANCELLED: "CANCELLED"
};

const CAMPAIGN_STEPS = {
  CAMPAIGN_STEP_PREVIEW: "preview",
  CAMPAIGN_STEP_OVERVIEW: "overview",
  CAMPAIGN_STEP_BUDGET_CHECK: "budget-check",
  CAMPAIGN_STEP_CHECKOUT: "checkout"
};

const CAMPAIGN_TYPES = {
  ASSISTANT_CAMPAIGN: "assistant"
};

export const UpdateCampaignSchema = z
  .object({
    id: z.string(),
    jobTitle: z.string(),
    companyName: z.string(),
    locations: z.array(LocationSchema),
    jobPostLink: z.string(),
    keywords: z.array(z.string()),

    jobCategoryId: z.string(),
    defaultText: z.object({
      long: z.string()
    }),

    messages: z.array(z.object({}).passthrough()),
    organizationId: z.string(),
    organizationName: z.string(),
    companyId: z.string(),

    adIds: z.array(z.string()),

    createdDate: z.string(),
    updatedDate: z.string().nullable(),
    mediaArray: z.array(MediaSchema),
    status: z.enum(Object.values(CAMPAIGN_STATUS)),

    step: z.enum(Object.values(CAMPAIGN_STEPS)),
    type: z.enum(Object.values(CAMPAIGN_TYPES)),

    deployed: z.boolean(),
    campaignName: z.string(),
    jobPostingUrl: z.string(),
    selectedChannels: z.array(z.object({}).passthrough()),
    channels: z.array(z.string()),

    lifeTimeBudget: z.number(),
    source: z.string(),
    campaignDuration: z.number(),

    bookingStyle: z.string(),
    lastEditStage: z.string(),
    startDate: z.string().nullable(),
    minClicksPackage: z.any(),
    predictions: z.any(),

    campaignGoal: z.string(),
    campaignManager: z.string(),
    userName: z.string(),
    userId: z.string(),

    packages: z.array(z.any()).default([]),
    packageId: z.string(),
    poNumber: z.string(),
    sourceTrigger: z.any(),
    optimizeAnalysis: z.any(),
    feedbackAnalysis: z.any(),
    spotifyHumanVoice: z.any(),
    isLoadingInvoiceAddresses: z.boolean().default(false),
    isFirstCampaign: z.boolean().default(false),
    isLocked: z.boolean().default(false),
    lockedBy: z.string().optional().nullable(),
    lockedUserId: z.string().optional().nullable(),
    lockedDate: z.string().optional().nullable(),
    activeDate: z.string().optional().nullable(),
    locale: z.string().optional().nullable(),
    isRemoteJob: z.boolean().optional().nullable().default(false)
  })
  .partial();
